import { IconListElement, Separator, Text } from "@nju/ui";
import { addPeriodToDate, formatDate } from "@nju/utils";

interface ISidebarOfferBenefitsProps {
  anniversaryDate: number | undefined;
}

export function SidebarInternationalOfferBenefits({
  anniversaryDate,
}: ISidebarOfferBenefitsProps) {
  const anniversaryDatePackage = (
    <>
      <Text weight="bold">ważność pakietu</Text>
      {anniversaryDate && (
        <>
          <Separator size="none" tone="invisible" />
          <Text size="s">
            pakiet będzie ważny do{" "}
            {formatDate(addPeriodToDate(anniversaryDate))}
          </Text>
        </>
      )}
    </>
  );

  return (
    <IconListElement
      iconAlign="start"
      iconName="history"
      iconSize="medium"
      mode="raw"
      text={anniversaryDatePackage}
    />
  );
}
